module.exports = __webpack_public_path__ + "img/Profil_CS-Slimlinerii_Volume.fa90bde0.jpg";